<template>
  <div
    data-testid="studio-toast-container"
    class="!tw-pointer-events-auto tw-flex tw-items-center tw-gap-4 tw-rounded-lg tw-bg-white tw-p-4 tw-text-black tw-shadow-md"
    role="alert"
  >
    <div>
      <StudioToastSuccessIcon v-if="mode === 'success'" data-testid="toast-success-icon" class="tw-h-5 tw-w-5" />
      <StudioToastErrorIcon v-else-if="mode === 'error'" data-testid="toast-error-icon" class="tw-h-5 tw-w-5" />
    </div>
    <div class="tw-max-w-lg">
      <p v-if="hasLink" v-html="message" />
      <p v-else>{{ message }}</p>
    </div>
    <StudioButton
      v-if="action"
      trackingId="studio-toast-action-button"
      variant="outline"
      size="small"
      @click="action.callback"
    >
      {{ action.label }}
    </StudioButton>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import StudioToastErrorIcon from './Icons/toast/StudioToastErrorIcon.vue';
import StudioToastSuccessIcon from './Icons/toast/StudioToastSuccessIcon.vue';
import StudioButton from './StudioButton.vue';

export default defineComponent({
  name: 'StudioToast',
  components: {
    StudioToastSuccessIcon,
    StudioToastErrorIcon,
    StudioButton
  },
  props: {
    mode: {
      type: String,
      required: true,
      validator: (prop: string) => ['success', 'error'].includes(prop)
    },
    message: {
      type: String,
      required: true
    },
    delay: {
      type: Number,
      default: 6000
    },
    action: {
      type: Object as PropType<{ label: string; callback: () => void }>,
      default: null
    }
  },
  data() {
    return {
      timeoutId: null as number | null
    };
  },
  mounted() {
    this.timeoutId = window.setTimeout(() => {
      this.handleClose();
    }, this.delay);
  },
  unmounted() {
    clearTimeout(this.timeoutId!);
  },
  computed: {
    hasLink(): boolean {
      const linkPattern = /<a\s+(?:[^>]*?\s+)?href=['"]?(.*?)["'>]/i;
      return linkPattern.test(this.message);
    }
  },
  methods: {
    handleClose(): void {
      clearTimeout(this.timeoutId!);
      this.$emit('close');
    }
  }
});
</script>
